import React, { forwardRef } from 'react';
import MuiAvatar, { AvatarProps } from '@mui/material/Avatar';

import placeholderLogo from './assets/placeholder_avatar.svg';

export type { AvatarProps };

export const LetterAvatar = forwardRef<any, AvatarProps>((props, ref) => {
  if (!props.children) {
    return <MuiAvatar {...props} src={placeholderLogo} ref={ref} />;
  }

  return <MuiAvatar {...props} ref={ref} />;
});
